import { FaIcon, faUsers } from '@/lib/fa'
import { useGroupsForm } from '@/modules/drivers/context/GroupsFormContext'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GroupsModalFooter = ({ onClick, open }) => {
  const { t } = useLocalize()
  const isReadyToSubmit = true
  const { selected } = useGroupsForm()
  const selectedDefaultGroups = ['1']

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-t tw-border-base-300 tw-px-4">
      <div className="tw-my-4 tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-content-base/80">
        {t('driverModule.added-to')}
        <strong className="tw-text-content-base">
          {selectedDefaultGroups.length}
        </strong>
        {t('driverModule.default-and-to')}
        <strong className="tw-text-content-base">{selected.length}</strong>
        {t('driverModule.custom-groups')}
      </div>
      <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
        <button
          onClick={() => open()}
          type="button"
          className={`tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-bg-secondary tw-p-3 tw-text-sm tw-font-medium hover:tw-opacity-80`}
        >
          <FaIcon
            icon={faUsers}
            className="tw-cursor-pointer tw-text-primary"
          />
          <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-primary">
            {t('driverModule.new-group')}
          </p>
        </button>
        <button
          type="button"
          onClick={() => onClick()}
          className={`tw-rounded-lg tw-p-3 tw-text-sm tw-font-medium tw-text-content-base hover:tw-opacity-80 ${isReadyToSubmit ? 'tw-cursor-pointer tw-bg-primary tw-text-white' : 'tw-cursor-not-allowed tw-bg-gray-300 tw-text-gray-500'} `}
        >
          {t('common.confirm')}
        </button>
      </div>
    </div>
  )
}

export default GroupsModalFooter
